export class CaseInsensitiveMap<V> extends Map<string, V> {
    public override delete(key: string): boolean {
        if (key == null) {
            return false;
        }

        key = key.toLowerCase();

        return super.delete(key);
    }

    public override get(key: string): V | undefined {
        if (key == null) {
            return undefined;
        }

        key = key.toLowerCase();

        return super.get(key);
    }

    public override has(key: string): boolean {
        if (key == null) {
            return false;
        }

        key = key.toLowerCase();

        return super.has(key);
    }

    public override set(key: string, value: V): this {
        key = key.toLowerCase();
        return super.set(key, value);
    }
}
